export default {
    BATTING: 'batting',
    PITCHING: 'pitching',
    BATTERS: 'batters',
    PITCHERS: 'pitchers',
    BENCH: 'bench',
    BULLPEN: 'bullpen'
};

export const dataTypes = {
    batting: 'batting',
    pitching: 'pitching',
    bench: 'batting',
    bullpen: 'pitching'
};

export const seasonStatsMap = {
    batting: {
        avg: true,
        ops: true,
        era: true
    },
    pitching: {
        avg: true,
        ops: true,
        era: true
    },
    bench: {
        avg: true,
        gamesPlayed: true,
        runs: true,
        homeRuns: true,
        hits: true,
        rbi: true,
        stolenBases: true
    },
    bullpen: {
        era: true,
        inningsPitched: true,
        baseOnBalls: true,
        hits: true,
        strikeOuts: true
    }
};
